module.exports = __webpack_public_path__ + "static/media/download-gray.4eb20705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/download-gray.svg
// module id = 1928
// module chunks = 0